import { render, staticRenderFns } from "./ChargeFee.vue?vue&type=template&id=3108a7ce&"
import script from "./ChargeFee.vue?vue&type=script&lang=js&"
export * from "./ChargeFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports